export const NO_DATA_PLACEHOLDER_CATEGORY_KEY = 'base' as const;
export const NO_DATA_PLACEHOLDER_COMPONENT_KEY = 'noDataPlaceholder' as const;
